import { UserAddOutlined } from '@ant-design/icons'
import { Button, Card, Empty, Form, Input } from 'antd'
import PropTypes from 'prop-types'
import React from 'react'
import Delete from '~/components/deleteConfirm'
import Signer from '../signer'

const Party = ({ party, partyIndex, updateParty, removeParty }) => {
	const handleAddSigner = () => {
		const newSigner = {
			title: '',
			anchor: [
				{
					anchor_string: '',
					anchor_x_offset: 0.0,
					anchor_y_offset: 0.0,
				},
			],
			fields: [
				{
					type: 'text',
					label: '',
					value: 'Nome',
					variable: '',
				},
				{
					type: 'email',
					label: '',
					value: 'Email',
					variable: '',
				},
			],
			status: '',
			signing_date: '',
		}
		updateParty(
			{ ...party, signers: [...party.signers, newSigner] },
			partyIndex
		)
	}

	const updateSigner = (signer, partyIndex, signerIndex) => {
		const updatedParty = {
			...party,
			signers: [
				...party.signers.map((s, index) =>
					index === signerIndex ? signer : s
				),
			],
		}
		updateParty(updatedParty, partyIndex)
	}

	const handleRemoveSigner = (signerIndex) => {
		const updatedParty = {
			...party,
			signers: [...party.signers.filter((_, index) => index !== signerIndex)],
		}
		updateParty(updatedParty, partyIndex)
	}

	const handleUpdateParty = (e) => {
		const updatedParty = { ...party, title: e.target.value }
		updateParty(updatedParty, partyIndex)
	}

	return (
		<Card
			style={{
				marginBottom: '1rem',
				boxShadow: '0 1px 4px 0 rgba(192, 208, 230, 0.8)',
				borderRadius: '5px',
			}}
			key={partyIndex}>
			<div
				style={{
					display: 'flex',
					justifyContent: 'space-between',
					alignItems: 'center',
					marginBottom: '24px',
				}}>
				<Form.Item
					name={`party_${partyIndex}`}
					label="Parte"
					style={{ width: '50%', margin: '0 0 0 8px' }}
					onChange={handleUpdateParty}
					initialValue={party.title}
					rules={[{ required: true, message: 'Este campo é obrigatório.' }]}>
					<Input value={party.title} />
				</Form.Item>
				<Delete handle={removeParty} title="Deseja excluir essa parte?" />
			</div>
			{party.type === 'database' ? (
				<Empty description="Database party" style={{ marginBottom: '1rem' }} />
			) : !party.signers?.length ? (
				<Empty description="Sem Assinantes" style={{ marginBottom: '1rem' }} />
			) : (
				party.signers.map((signer, index) => (
					<Signer
						key={index}
						signer={signer}
						partyIndex={partyIndex}
						signerIndex={index}
						updateSigner={updateSigner}
						removeSigner={() => handleRemoveSigner(index)}
					/>
				))
			)}
			{party.type !== 'database' && (
				<Button
					onClick={() => handleAddSigner(party.title)}
					type="primary"
					icon={<UserAddOutlined />}
					style={{
						display: 'inline-block',
						float: 'right',
					}}>
					Novo Signatário
				</Button>
			)}
		</Card>
	)
}

export default Party

Party.propTypes = {
	party: PropTypes.shape({
		title: PropTypes.string,
		type: PropTypes.string,
		signers: PropTypes.array,
	}),
	partyIndex: PropTypes.number,
	updateParty: PropTypes.func,
	removeParty: PropTypes.func,
}
